module.exports = __webpack_public_path__ + "img/member_cards_icon_431008.c6c848e6.png";